import RCTEventEmitter from 'react-native/Libraries/vendor/emitter/EventEmitter';

export { RCTEventEmitter };
